export default __webpack_public_path__ + "media/images/logo/instagram-a2cd6f49fd00351b65715352d75d42aa.svg";